import styled from 'styled-components'

export const StyledBadgeHeading = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: -12px;
  margin-top: 0px;
`

export const StyledBadgeIcon = styled.span`
  ${({ theme: { space, colors } }): string => `
    margin-right: ${space.sm};
    margin-left: ${space.xs};
    svg {
      width: 60px;
      height: 60px;
      -webkit-filter: drop-shadow( 3px 3px 2px ${colors['slate-2']});
      filter: drop-shadow( 3px 3px 2px ${colors['slate-2']});
    }
  `}
`
